export function getText(emails) {
  return `${emails.length} ${
    emails.length > 1 ? 'profiles' : 'profile'
  } with same email`
}
